import React, { useState } from "react";
import "./PopupTestDrive.css";

const PopupTestDrive = ({ onClose }) => {
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  // Validation (FormData safe)
  const validateForm = (formData) => {
    let newErrors = {};

    const name = (formData.get("name") || "").trim();
    const phone = (formData.get("phone") || "").trim();
    const email = (formData.get("email") || "").trim();
    const scooty = (formData.get("scooty") || "").trim();
    const date = (formData.get("date") || "").trim();
    const time = (formData.get("time") || "").trim();

    if (!name || name.length < 3)
      newErrors.name = "Name must be at least 3 characters";

    if (!phone) newErrors.phone = "Phone number is required";
    else if (!/^[0-9]{10}$/.test(phone))
      newErrors.phone = "Enter valid 10 digit phone number";

    if (!email) newErrors.email = "Email is required";
    else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email))
      newErrors.email = "Invalid email address";

    if (!scooty) newErrors.scooty = "Please select scooty";
    if (!date) newErrors.date = "Please select date";
    if (!time) newErrors.time = "Please select time";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // Submit
  const handleSubmit = (e) => {
    e.preventDefault();

    const formEle = e.target;
    const formData = new FormData(formEle);

    if (!validateForm(formData)) return;

    setLoading(true);

    fetch(
      "https://script.google.com/macros/s/AKfycbwjhQZZ-StFVC3e3HxQRPm25FsYLpxJsAb1lfssowEvA5IWMz4DgTLha8T8KmL0lCj6/exec",
      {
        method: "POST",
        body: formData,
      }
    )
      .then((res) => res.json())
      .then(() => {
        formEle.reset();
        setErrors({});
        setShowSuccess(true);
      })
      .catch(() => {
        alert("Test drive booking failed!");
      })
      .finally(() => setLoading(false));
  };

  return (
    <div className="popup-overlay">
      {/* FULLSCREEN LOADER */}
      {loading && (
        <div className="fullscreen-loader">
          <div className="loader"></div>
          <p>Submitting your test drive...</p>
        </div>
      )}

      {/* SUCCESS POPUP */}
      {showSuccess && (
        <div className="success-overlay">
          <div className="success-popup">
            <div className="success-icon">✅</div>
            <h3>Test Drive Booked!</h3>
            <p>Scooty booked successfully 🚀</p>
            <button
              onClick={() => {
                setShowSuccess(false);
                onClose();
              }}
            >
              OK
            </button>
          </div>
        </div>
      )}

      <div className="popup-box">
        <span className="popup-close" onClick={onClose}>
          ✕
        </span>

        <h2 className="popup-title">Book Your Test Drive</h2>

        <form className="popup-form" onSubmit={handleSubmit} noValidate>
          <div>
            <input type="text" name="name" placeholder="Name" />
            {errors.name && <p className="error-text">{errors.name}</p>}
          </div>

          <div>
            <input type="tel" name="phone" placeholder="Phone Number" />
            {errors.phone && <p className="error-text">{errors.phone}</p>}
          </div>

          <div>
            <input type="email" name="email" placeholder="Email ID" />
            {errors.email && <p className="error-text">{errors.email}</p>}
          </div>

          <div>
            <select name="scooty">
              <option value="">Select Vehicle</option>
              <option value="NOVA">NOVA</option>
              <option value="NOVA-S">NOVA-S</option>
              <option value="NOVA-X">NOVA-X</option>
              <option value="EDGE">EDGE</option>
              <option value="EDGE PLUS">EDGE PLUS</option>
              <option value="ELITE 5G">ELITE 5G</option>
              <option value="ELITE 5G-2.0">ELITE 5G-2.0</option>
              <option value="WARIVO NEO">WARIVO NEO</option>
              <option value="SHARK">SHARK</option>
              <option value="ALEXA">ALEXA</option>
              <option value="CRUZE">CRUZE</option>
              <option value="L1-PLUS">L1-PLUS</option>
              <option value="REVO BOAT">REVO BOAT</option>
            </select>
            {errors.scooty && <p className="error-text">{errors.scooty}</p>}
          </div>

          <div>
            <input type="date" name="date" />
            {errors.date && <p className="error-text">{errors.date}</p>}
          </div>

          <div>
            <input type="time" name="time" />
            {errors.time && <p className="error-text">{errors.time}</p>}
          </div>

          <button type="submit" disabled={loading}>
            Book Test Drive
          </button>
        </form>
      </div>
    </div>
  );
};

export default PopupTestDrive;
